import React from "react"
import { createIcon } from "@chakra-ui/react"

export const MagicIcon = createIcon({
  viewBox: "0 0 64 65",
  defaultProps: {
    width: "64",
    height: "65",
    fill: "none",
  },

  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.1472 0.504443C46.3155 0.707806 57.5507 9.38486 61.8158 21.851C66.3116 34.9913 64.1079 50.1773 52.9856 58.4885C41.4509 67.1079 25.551 66.1356 13.9283 57.6353C2.41285 49.2135 -2.93122 34.4468 1.61874 20.9213C6.03356 7.7976 19.3083 0.290725 33.1472 0.504443Z"
        fill="#EC79A2"
      />
      <path
        d="M16.6514 39.5867C17.7099 37.5883 14.7122 36.0005 13.6537 37.9989C12.5951 39.9974 15.5929 41.5852 16.6514 39.5867Z"
        fill="white"
      />
      <path
        d="M25.0521 36.4023C26.3312 27.3489 29.3018 25.6978 34.5511 25.364L34.5008 25.3638C30.2201 25.347 26.5258 25.3325 26.6829 15.7705C25.7199 19.9379 26.1106 24.8728 17.0604 25.3047C25.1043 27.1475 23.8944 28.236 25.0521 36.4023Z"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.0578 22.2808C46.5042 21.4663 45.2824 19.2967 43.836 20.1112C42.3895 20.9258 43.6114 23.0954 45.0578 22.2808Z"
        fill="white"
      />
      <path
        d="M41.8687 40.7009C40.1237 36.2385 41.9322 35.5173 44.2344 33.8472C41.664 34.5369 39.259 35.4071 36.8635 31.0224C37.4965 33.1848 38.5502 35.9944 34.5442 38.8087C38.6771 37.3138 39.2431 37.3447 41.8687 40.7009Z"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.736 42.2673C51.4786 41.2859 50.0066 38.6719 48.2639 39.6533C46.5212 40.6347 47.9933 43.2487 49.736 42.2673Z"
        fill="white"
      />
      <path
        d="M35.6033 50.7329C36.7651 50.0786 35.7837 48.336 34.6219 48.9902C33.4601 49.6445 34.4415 51.3871 35.6033 50.7329Z"
        fill="white"
      />
    </>
  ),
})
